export interface IHorarios{
  idPaciente:  any;
	idMedicamento:  any;
	codigo:  any;
	titulo:  any;
	habilitado:  boolean;
	hora:  any;
	idMedicamentoIdPaciente:  any;
}
